import { useState, useContext } from "react"
import {
    doc,
    updateDoc,
} from "firebase/firestore"
import { db } from "../firebase";
import Button from 'react-bootstrap/Button';
import AddressAutocompleteProvider from "./helperComponents/AddressAutocompleteProvider";
import ModalWrapper from "./ModalWrapper";
import { getAddressData, handleImageDeletion, handleUpload } from "../helpers/HelperFunctions";
import { AuthContext } from "../context/AuthContext"
import {Tooltip} from 'react-tooltip' 

const EditProfileModal = ({editProfileOpen, setEditProfileOpen, user}) => {
    const addressTooltip = "This will be the default location for your listings and the center of your map. A full address or specific location will make the marker placed on the map more accurate!"

    const { currentUser } = useContext(AuthContext)

    const [avatarUrl, setAvatarUrl] = useState(user.avatarUrl)
    const [firstName, setFirstName] = useState(user.firstName)
    const [lastName, setLastName] = useState(user.lastName)
    const [birthday, setBirthday] = useState(user.birthday)
    const [address, setAddress] = useState(user.address)

    const [uploadFiles, setUploadFiles] = useState([])

    // const [newChatEmailNotif, setNewChatEmailNotif] = useState(null);
    // const [allMessagesEmailNotif, setAllMessagesEmailNotif] = useState(null);
    const [newChatEmailNotif, setNewChatEmailNotif] = useState(currentUser.uid === user.uid ? user.notificationSettings.newChatEmailNotif : false);
    const [allMessagesEmailNotif, setAllMessagesEmailNotif] = useState(currentUser.uid === user.uid ? user.notificationSettings.allMessagesEmailNotif : false);
    // if(currentUser.uid === user.uid) {
    //     setNewChatEmailNotif(user.notificationSettings.newChatEmailNotif ? user.notificationSettings.newChatEmailNotif : false)
    //     setAllMessagesEmailNotif(user.notificationSettings.allMessagesEmailNotif ? user.notificationSettings.allMessagesEmailNotif : false)
    // }

    const handleMasterChange = (e) => {
        const isChecked = e.target.checked;
        setNewChatEmailNotif(isChecked);
        
        // Requirement: If master is unchecked, uncheck the child
        if (!isChecked) {
            setAllMessagesEmailNotif(false);
        }};

    const onEditSave = async (e) => {
        e.preventDefault()
        try{
            const dataObj = {}
            const privDataObj = {}
            if (avatarUrl !== user.avatarUrl) {
                dataObj.avatarUrl = avatarUrl
            }
            if (uploadFiles.length > 0) {
                const uploadedUrls = await handleUpload(uploadFiles)
                dataObj.avatarUrl = uploadedUrls[0]
            } 
            if (firstName !== user.firstName) {
                dataObj.firstName = firstName
            } 
            if (lastName !== user.lastName) {
                dataObj.lastName = lastName
            } 

            if (birthday !== user.birthday) {
                privDataObj.birthday = birthday
            } 
            // if (address !== user.addressData.formattedAddress) {
            if (address !== user.address) {
                const addressData = await getAddressData(address)
                privDataObj.addressData = addressData
            } 
            if (!user.notificationSettings.newChatEmailNotif || newChatEmailNotif !== user.notificationSettings.newChatEmailNotif) {
                privDataObj["notificationSettings.newChatEmailNotif"] = newChatEmailNotif
            } 
            if (!user.notificationSettings.allMessagesEmailNotif || allMessagesEmailNotif !== user.notificationSettings.allMessagesEmailNotif) {
                privDataObj["notificationSettings.allMessagesEmailNotif"] = allMessagesEmailNotif
            } 
            console.log(dataObj)
            console.log(privDataObj)
            if (Object.keys(dataObj).length > 0) {
                await updateDoc(
                    doc(db, "users", user.uid), dataObj
                )
            }
            if (Object.keys(privDataObj).length > 0) {
                await updateDoc(
                    doc(db,`users/${user.uid}/private`, "data"), privDataObj
                )
            }
            //update first names on active chats
            // if ((firstName !== user.firstName) && (user.activeChats.length > 0)) {
            //     for (const activeChat of user.activeChats) {
            //         if (activeChat.from.uid === user.uid) {
            //             await updateDoc(
            //                 doc(db, "chatrooms", user.uid), 
            //                 {
            //                     "activeChats.from.firstName": firstName
            //                 }
            //             )
            //         } else {
            //             await updateDoc(
            //                 doc(db, "users", user.uid), 
            //                 {
            //                     "activeChats.to.firstName": firstName
            //                 }
            //             )
            //         }
            //     }
            // }
            if ((firstName !== user.firstName) && (user.activeListings.length > 0)) {
                for (const activeListing of user.activeListings) {
                    await updateDoc(
                        doc(db, "listings", activeListing), 
                        {
                            "user.firstName": firstName
                        }
                    )
                }
            }
            window.location.reload()
        } catch(err) {
            console.log(err)
        }
    }

    const onAvatarDelete = (e) => {
        const publicId = avatarUrl.split("/").pop().split(".")[0]
        handleImageDeletion(publicId)
        .then(res => {
            setAvatarUrl("")
        })
    }
    
    return (
        editProfileOpen && <ModalWrapper
            show={editProfileOpen}
            onHide={() => setEditProfileOpen(false)}
            heading="Edit Profile"
        >
            <div className="edit-images-carousel">
                <div>
                    <div>Avatar:</div>
                    {avatarUrl && 
                    <div className="edit-images-box">
                        <div onClick={onAvatarDelete} className="x-delete-button">
                            <div className="x-container"></div>
                        </div>
                        <img className="edit-images-thumbnail" src={avatarUrl}/>
                    </div>
                    }
                </div>
            </div>
            <input type="file" id="file-upload" className="hidden-file-input" onChange={e => setUploadFiles(e.target.files)} accept="image/png, image/jpeg"/>
            <label for="file-upload" className="file-upload-label btn btn-secondary">
                Choose Image
            </label>
            
            <div className="edit-profile-item">
                <div>First Name:</div>
                <input type="test" className="form-input" value={firstName} onChange={e => setFirstName(e.target.value)} required/>
            </div>
            <div className="edit-profile-item">    
                <div>Last Name:</div>
                <input type="test" className="form-input" value={lastName} onChange={e => setLastName(e.target.value)}/>
            </div>
            <div className="only-user-visible">
                <h5>Private Settings</h5>
                <div className="settings-section">
                    <div className="edit-profile-item">
                        <div>Birthday:</div>
                        <input className="form-input" type="date" id="datePickerId" min="1900-01-01" 
                            value={birthday}
                            max={new Date().toISOString().split("T")[0]} 
                            onChange={e=> setBirthday(e.target.value)}
                            required/>
                    </div>
                    <div className="edit-profile-item">
                        <div className="input-with-tooltip" style={{display: 'block'}}>
                            <span>Default Pick-up Location</span>    
                            <span className="tooltip-helper" data-tooltip-id="address-tooltip" style={{display: 'inline-flex'}}>i</span>
                        </div>

                        <AddressAutocompleteProvider address={address} setAddress={setAddress}/>
                    </div>
                </div>

                <div className="settings-section notifications">
                    <b>Email Notification Settings</b>
                    {/* Overall Notifications */}
                    <div>
                        <label>
                        <input 
                            type="checkbox" 
                            checked={newChatEmailNotif} 
                            onChange={handleMasterChange} 
                        />
                        Get notified when someone new messages you
                        </label>
                    </div>

                    {/* Message Notifications */}
                    <div style={{ marginLeft: '20px', color: !newChatEmailNotif ? '#888' : '#000' }}>
                        <label>
                        <input 
                            type="checkbox" 
                            checked={allMessagesEmailNotif} 
                            disabled={!newChatEmailNotif} // Disable if master is unchecked
                            onChange={(e) => setAllMessagesEmailNotif(e.target.checked)} 
                        />
                        Get notified for every new message
                        </label>
                    </div>
                </div>
            </div>
            {/* <div className="edit-profile-item">
                <div>E-mail:</div>
                <input type="test" className="form-input" value={title} onChange={e => setTitle(e.target.value)}/>
            </div> */}

            <Button className="btn btn-primary" 
                onClick={
                    (e) => {
                        onEditSave(e)
                        setEditProfileOpen(false)
                    }
                }
            >Save</Button>
            <Button className="btn btn-secondary" data-bs-dismiss="modal" 
                onClick={
                    () => {
                        //reset edit fields
                        setFirstName(user.firstName)
                        setLastName(user.lastName)
                        setBirthday(user.birthday)
                        // setAddress(user.addressData.formattedAddress)
                        setAddress(user.address)
                        setUploadFiles([])
                        
                        setEditProfileOpen(false)
                    }
                }
            >Cancel</Button>

            <Tooltip className="tooltip" id="address-tooltip" place="top" style={{display: 'flex', flexDirection: 'column'}}> 
                <span>This will be the default location for your listings and the center of your map.</span>
                <span>A full address or specific location will make the marker placed on the map more accurate!</span>
            </Tooltip>
        </ModalWrapper>
    )
}

export default EditProfileModal